import type { SVGProps } from 'react';
export const SvgPrev = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		aria-hidden="true"
		className="w-6 h-6 text-white"
		viewBox="0 0 8 14"
		{...props}
	>
		<path
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="M7 1 1.3 6.326a.91.91 0 0 0 0 1.348L7 13"
		/>
	</svg>
);
